// As other Forms get refactored, this file can be shifted to a more generic location
export const GenerateErrorMessage = (
  errors: Record<string, any>,
  input: string
) => {
  let hasErrorProperty = Object.prototype.hasOwnProperty.call(errors, input);
  if (hasErrorProperty) {
    return (
      <p
        className={`absolute left-2.5 translate-y-3 pt-1 text-[0.85rem] leading-4 text-red-500 ${input === 'consent' || input === 'serialNumber' ? '-bottom-7' : '-bottom-[1px]'}`}
      >
        {errors[input].message}
      </p>
    );
  }
};

export const InputField = ({
  name,
  placeholder,
  type = 'text',
  register,
  errors,
  validation,
  className,
}: {
  name: string;
  placeholder: string;
  type?: string;
  register: any;
  errors: any;
  validation?: any;
  className?: string;
}) => (
  <div className="relative">
    <input
      {...register(name, validation)}
      placeholder={placeholder}
      type={type}
      className={`my-2 w-full border-b border-b-grey-1 p-2 font-acumin text-[16px] placeholder:text-grey-1 ${className}`}
    />
    {errors && GenerateErrorMessage(errors, name)}
  </div>
);

export const TextAreaField = ({
  name,
  placeholder,
  register,
  errors,
  validation,
}: {
  name: string;
  placeholder: string;
  register: any;
  errors: any;
  validation: any;
}) => (
  <div className="relative mt-6">
    <textarea
      {...register(name, validation)}
      placeholder={placeholder}
      className="my-2 w-full border-b border-b-grey-1 p-2 pb-[75px] font-acumin text-[16px] text-grey-1 placeholder:text-grey-1"
    />
    {errors && GenerateErrorMessage(errors, name)}
  </div>
);
